import authHeader from '../helpers/authHeader';

const ROOT_URL = '/api';

export const userService = {
  signin,
  signout,
  getUserFromToken,
  authenticateWithToken,
  register,
  resetPassword
};

function signin(formValues) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formValues),
  };

  let response;

  return fetch(`${ROOT_URL}/authenticate`, requestOptions)
    .then(res => {
      response = res;
      return response.json();
    })
    .then(resJSON => {
      if (!response.ok) {
        if (resJSON.errors && resJSON.errors.length > 0) {
          return Promise.reject(resJSON.errors[0].detail);
        } else {
          return Promise.reject(response.statusText);
        }
      }
      if (resJSON.user && resJSON.auth_token) {
        localStorage.setItem('auth_token', JSON.stringify(resJSON.auth_token));
      }

      return resJSON;
    })
}

function signout() {
  // remove user from local storage to log user out
  localStorage.removeItem('auth_token');
}

function getUserFromToken() {
  const requestOptions = {
    headers: authHeader(),
  }

  return fetch(`${ROOT_URL}/me`, requestOptions)
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText)
      }
      return response.json()
    })
}

function authenticateWithToken(token) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({token: token}),
  };

  let response;

  return fetch(`${ROOT_URL}/authenticate-token`, requestOptions)
    .then(res => {
      response = res;
      return response.json();
    })
    .then(resJSON => {
      if (!response.ok) {
        if (resJSON.errors && resJSON.errors.length > 0) {
          return Promise.reject(resJSON.errors[0].detail);
        } else {
          return Promise.reject(response.statusText);
        }
      }

      if (resJSON.user && resJSON.auth_token) {
        localStorage.setItem('auth_token', JSON.stringify(resJSON.auth_token));
      }
      return resJSON;
    })
}

function register(email, passwordDigest) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      user: {
        email: email,
        password_digest: passwordDigest,
      }
    }),
  };

  let response;

  return fetch(`${ROOT_URL}/users/register`, requestOptions)
    .then(res => {
      response = res;
      return response.json();
    }).then(resJSON => {
      if (!response.ok) {
        if (resJSON.errors && resJSON.errors.length > 0) {
          return Promise.reject(resJSON.errors.map((error)=>{return error['detail'];}).join('<br>'));
        } else {
          return Promise.reject(response.statusText);
        }
      }
      return resJSON;
    });
}

function resetPassword(email) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      user: {
        email: email
      }
    }),
  };

  let response;

  return fetch(`${ROOT_URL}/users/reset-password`, requestOptions)
    .then(res => {
      response = res;
      return response.json();
    }).then(resJSON => {
      if (!response.ok) {
        if (resJSON.errors && resJSON.errors.length > 0) {
          return Promise.reject(resJSON.errors[0].detail);
        } else {
          return Promise.reject(response.statusText);
        }
      }
      return resJSON;
    });
}
